export default "__VITE_ASSET__Dc_n4Xcg__"